import {
  Card,
  CardActionArea,
  CardContent,
  Typography
} from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRightRounded';
import { NavLink, Route, Switch, useRouteMatch } from 'react-router-dom';
import { HELP_TOPICS } from '../../constants/helpTopics';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../Breadcrumb';
import CreateDocumentWorkflow from './CreateDocumentWorkflow';
import DocumentAccessControl from './DocumentAccessControl';
import FollowDocument from './FollowDocument';
import HelpTopic from './HelpTopic';
import ManageMember from './ManageMember';
import PlanDocument from './PlanDocument';
import ReviewDocument from './ReviewDocument';
import SetupProject from './SetupProject';
import SetupProjectWorkflow from './SetupProjectWorkflow';
import UserAccessControl from './UserAccessControl';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(1.5, 0, 12, 0)
    },
    title: {
      margin: theme.spacing(1.5, 0, 2, 0),
      [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
        margin: theme.spacing(3.5, 0, 4, 0)
      }
    },
    card: {
      width: 360,
      margin: theme.spacing(1)
    },
    menu: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      marginTop: theme.spacing(2)
    },
    media__box: {
      display: 'flex',
      justifyContent: 'center'
    },
    media: {
      height: 200
    },
    header__menu: {
      display: 'flex',
      alignItems: 'center'
    },
    header__label: {
      flexGrow: 1
    },
    header__labelH2: {
      marginTop: theme.spacing(-1)
    },
    header__labelP: {
      marginBottom: theme.spacing(-0.5),
      lineHeight: '120%',
      wordWrap: 'break-word'
    }
  })
);

export default function Help() {
  let { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/projects/setup-project`}>
        <SetupProject />
      </Route>
      <Route exact path={`${path}/projects/setup-project-workflow`}>
        <SetupProjectWorkflow />
      </Route>
      <Route exact path={`${path}/projects/manage-member`}>
        <ManageMember />
      </Route>
      <Route exact path={`${path}/documents/plan-document`}>
        <PlanDocument />
      </Route>
      <Route exact path={`${path}/documents/create-document-workflow`}>
        <CreateDocumentWorkflow />
      </Route>
      <Route exact path={`${path}/documents/review-approve-document`}>
        <ReviewDocument />
      </Route>
      <Route exact path={`${path}/documents/follow-up-document`}>
        <FollowDocument />
      </Route>
      <Route exact path={`${path}/permissions/document-access-control`}>
        <DocumentAccessControl />
      </Route>
      <Route exact path={`${path}/permissions/user-access-control`}>
        <UserAccessControl />
      </Route>
      <Route exact path={path}>
        <HelpPage />
      </Route>
      <Route path={`${path}/:helpTopicId`}>
        <HelpTopic />
      </Route>
    </Switch>
  );
}

function HelpPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Breadcrumb name="help" />
      <Typography className={classes.title} component="p" variant="h4">
        {t('menu.help.label')}
      </Typography>
      <Typography component="p" variant="body2">
        {t('help.main.description')}
      </Typography>
      <div className={classes.menu}>
        {HELP_TOPICS.map(({ labelKey, featureKey, to, imageSrc: src }) => (
          <Card className={classes.card} key={labelKey}>
            <CardActionArea component={NavLink} to={to}>
              <div className={classes.media__box}>
                <img className={classes.media} src={src} alt={String(t(labelKey))} />
              </div>
              <CardContent>
                <div className={classes.header__menu}>
                  <div className={classes.header__label}>
                    <Typography
                      className={classes.header__labelH2}
                      variant="h6"
                      component="h2"
                    >
                      {t(labelKey)}
                    </Typography>
                    <Typography
                      className={classes.header__labelP}
                      variant="caption"
                      component="p"
                      color="textSecondary"
                    >
                      {t(featureKey)}
                    </Typography>
                  </div>
                  <ChevronRightIcon />
                </div>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </div>
    </div>
  );
}
